<template>
  <div class="mb-4">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              v-model="cStartDateStatus"
              type="radio"
              value="0"
              class="custom-control-input"
              id="general"
              name="start_date_status"
            />
            <label class="custom-control-label" for="general">{{
              translate[lang]["general"]
            }}</label>
          </div>
          <div
            class="custom-control custom-radio custom-control-inline"
            v-if="selectedProducts.length > 0"
          >
            <input
              v-model="cStartDateStatus"
              type="radio"
              value="1"
              class="custom-control-input"
              id="perproduct"
              name="start_date_status"
            />
            <label class="custom-control-label" for="perproduct">{{
              translate[lang]["perproduct"]
            }}</label>
          </div>
        </div>
      </div>
      <div v-if="cStartDateStatus == 0" class="col-12">
        <flat-pickr
          name="start_date"
          value=""
          class="mb-2 mr-sm-2 mb-sm-0 form-control bg-transparent"
          :config="{
            allowInput: true,
            dateFormat: 'd-m-Y',
            minDate: 'today',
            disableMobile: 'true'
          }"
          v-model="cGeneralDate"
        ></flat-pickr>
      </div>
      <div
        v-if="
          cStartDateStatus == 1 &&
            !((item === 1 || item === 2) && checkElectricGas)
        "
        class="col-12 mb-3"
        v-for="(item, key) in selectedProducts"
        :key="key"
      >
        <label>{{
          item === 6 && checkElectricGas
            ? translate[lang]["electricityandgas"]
            : filterProduct(item).name[lang]
        }}</label>
        <flat-pickr
          v-if="item === 6"
          :name="'products[electricityandgas][start_date]'"
          value=""
          class="mb-2 mr-sm-2 mb-sm-0 form-control bg-transparent"
          :config="{
            dateFormat: 'd-m-Y',
            minDate: 'today',
            disableMobile: 'true',
            allowInput: true
          }"
          v-model="cElectricGasDate"
        ></flat-pickr>
        <flat-pickr
          v-else
          :name="'products[' + filterProduct(item).group + '][start_date]'"
          :value="getDate(filterProduct(item).group)"
          class="mb-2 mr-sm-2 mb-sm-0 form-control bg-transparent"
          :config="{
            dateFormat: 'd-m-Y',
            minDate: 'today',
            disableMobile: 'true',
            allowInput: true
          }"
          @input="v => updateDate(filterProduct(item).group, v)"
        ></flat-pickr>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "DateWidget",
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      startDateStatus: state => state.forms.startDateStatus,
      submitData: state => state.forms.SubmitData,
      generalDate: state => state.forms.generalDate,
      lookUpDate: state => state.forms.lookUpDate,
      electricGasDate: state => state.forms.electricGasDate
    }),
    cStartDateStatus: {
      get() {
        return this.startDateStatus;
      },
      set(val) {
        this.setStartDateStatus(val);
      }
    },
    cGeneralDate: {
      get() {
        return this.generalDate;
      },
      set(val) {
        this.setGeneralDate(val);
      }
    },
    cElectricGasDate: {
      get() {
        return this.electricGasDate;
      },
      set(val) {
        this.setElectricGasDate(val);
      }
    }
  },
  methods: {
    ...mapMutations({
      setStartDateStatus: "forms/SET_STARTDATE_STATUS",
      setGeneralDate: "forms/SET_GENERAL_DATE",
      setElectricGasDate: "forms/SET_ELECTRICGAS_DATE"
    }),
    getDate(product) {
      return this.lookUpDate.filter(a => a.key === product).length > 0
        ? this.lookUpDate.filter(a => a.key === product)[0].value
        : null;
    },
    updateDate(product, value) {
      if (this.lookUpDate.filter(a => a.key === product).length > 0) {
        this.lookUpDate.filter(a => a.key === product)[0].value = value;
      }
      this.lookUpDate.push({ key: product, value: value });
    }
  }
};
</script>
